import { MetaMenuOptions, TABS } from "../types/tabs";


export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export function setActiveTab(tab: TABS) {
	return {
		type: SET_ACTIVE_TAB,
		payload: tab,
	};
}

export const SET_ACTIVE_SUB_TAB = 'SET_ACTIVE_SUB_TAB';
export function setActiveSubTab(tab: TABS, subTab: string) {
	return {
		type: SET_ACTIVE_SUB_TAB,
		payload: {
			tab,
			subTab,
		},
	};
}

export const SET_RIGHT_DRAWER_OPEN = 'SET_RIGHT_DRAWER_OPEN';
export function setRightDrawerOpen(open: boolean) {
	return {
		type: SET_RIGHT_DRAWER_OPEN,
		payload: open,
	};
}

export const SET_META_MENU_ROUTE = 'SET_META_MENU_ROUTE';
export function setMetaMenuRoute(route: string) {
	return {
		type: SET_META_MENU_ROUTE,
		payload: route,
	};
}

export const SET_META_MENU_STATE = 'SET_META_MENU_STATE';
export function setMetaMenuState(metaMenuState: string) {
	return {
		type: SET_META_MENU_STATE,
		payload: metaMenuState,
	};
}

export const SET_META_MENU_OPTION = 'SET_META_MENU_OPTION';
export function setMetaMenuOption(option: MetaMenuOptions) {
	return {
		type: SET_META_MENU_OPTION,
		payload: option,
	};
}

export const CLOSE_META_MENU = 'CLOSE_META_MENU';
export function closeMetaMenu() {
	return {
		type: CLOSE_META_MENU,
	};
}

export const CLEAR_META_MENU_TRACKING = 'CLEAR_META_MENU_TRACKING';
export function clearMetaMenuTracking() {
	return {
		type: CLEAR_META_MENU_TRACKING,
	};
}

export const SET_RESTORED_META_ROUTE = 'SET_RESTORED_META_ROUTE';
export function setRestoredMetaRoute(restored: boolean) {
	return {
		type: SET_RESTORED_META_ROUTE,
		payload: restored,
	};
}
